// src/mixins/scrollToTopMixin.js
export default {
  mounted() {
    // Only scroll on mobile if you want
    // const isMobile = window.innerWidth <= 768
    // if (!isMobile) return

    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
}
